import { RFC2822_SPECIAL_CHARS } from '@this+that/constants';

export const formatSenderAddress = (
  name: string | undefined,
  email: string,
): string => {
  const trimmedName = name?.trim()?.replace(/[\r\n]/g, ' ');

  if (!trimmedName) {
    return email;
  }

  if (RFC2822_SPECIAL_CHARS.test(trimmedName)) {
    const escapedName = trimmedName.replace(/["\\]/g, '\\$&');
    return `"${escapedName}" <${email}>`;
  }

  return `${trimmedName} <${email}>`;
};

export const parseFormattedAddress = (
  address: string,
): { name: string | undefined; email: string } => {
  const trimmed = address.trim();
  const match = trimmed.match(/^(.*?)\s*<([^>]+)>$/);

  if (!match) {
    return { name: undefined, email: trimmed };
  }

  const email = match[2];
  let name = match[1].trim();

  if (!name) {
    return { name: undefined, email };
  }

  if (name.startsWith('"') && name.endsWith('"')) {
    name = name.slice(1, -1).replace(/\\(.)/g, '$1');
  }

  return { name, email };
};
